"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.rfqProjectStatusConfig = void 0;
const types_1 = require("../project/types");
const types_2 = require("../rfq/types");
exports.rfqProjectStatusConfig = [
    {
        rfqStatus: types_2.RFQStatus.PUBLISHED,
        projectStatus: types_1.ProjectStatus.COMPLETED,
    },
    {
        rfqStatus: types_2.RFQStatus.AWAITING_SUBMISSIONS,
        projectStatus: types_1.ProjectStatus.COMPLETED,
    },
    {
        rfqStatus: types_2.RFQStatus.SELECTED,
        projectStatus: types_1.ProjectStatus.COMPLETED,
    },
    {
        rfqStatus: types_2.RFQStatus.AWARDED,
        projectStatus: types_1.ProjectStatus.COMPLETED,
    },
    {
        rfqStatus: types_2.RFQStatus.IN_PROGRESS,
        projectStatus: types_1.ProjectStatus.IN_PROGRESS,
    },
    {
        rfqStatus: types_2.RFQStatus.REQUIRES_APPROVAL,
        projectStatus: types_1.ProjectStatus.IN_PROGRESS,
    },
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmZxLXByb2plY3Qtc3RhdHVzLW1hcHBpbmcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc3RhbnRzL3JmcS1wcm9qZWN0LXN0YXR1cy1tYXBwaW5nLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILDhDQUFtRDtBQUNuRCwwQ0FBMkM7QUFPOUIsUUFBQSxzQkFBc0IsR0FBK0I7SUFDaEU7UUFDRSxTQUFTLEVBQUUsaUJBQVMsQ0FBQyxTQUFTO1FBQzlCLGFBQWEsRUFBRSxxQkFBYSxDQUFDLFNBQVM7S0FDdkM7SUFDRDtRQUNFLFNBQVMsRUFBRSxpQkFBUyxDQUFDLG9CQUFvQjtRQUN6QyxhQUFhLEVBQUUscUJBQWEsQ0FBQyxTQUFTO0tBQ3ZDO0lBQ0Q7UUFDRSxTQUFTLEVBQUUsaUJBQVMsQ0FBQyxRQUFRO1FBQzdCLGFBQWEsRUFBRSxxQkFBYSxDQUFDLFNBQVM7S0FDdkM7SUFDRDtRQUNFLFNBQVMsRUFBRSxpQkFBUyxDQUFDLE9BQU87UUFDNUIsYUFBYSxFQUFFLHFCQUFhLENBQUMsU0FBUztLQUN2QztJQUNEO1FBQ0UsU0FBUyxFQUFFLGlCQUFTLENBQUMsV0FBVztRQUNoQyxhQUFhLEVBQUUscUJBQWEsQ0FBQyxXQUFXO0tBQ3pDO0lBQ0Q7UUFDRSxTQUFTLEVBQUUsaUJBQVMsQ0FBQyxpQkFBaUI7UUFDdEMsYUFBYSxFQUFFLHFCQUFhLENBQUMsV0FBVztLQUN6QztDQUNGLENBQUMifQ==